export const seo = {
  FullscriptAlt: "Fullscript logo in white on a green background",
} as const;
